export function toFarsiNumber(n) {
  const farsiDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  return n.toString().replace(/\d/g, (x) => farsiDigits[x]);
}

export function numberWithSeparator(x, decimalSeparator = null) {
  if (!decimalSeparator) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    if (Number.isInteger(x)) {
      return (
        x
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          .split(".")
          .join(decimalSeparator) +
        decimalSeparator +
        "۰"
      );
    } else {
      return x
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        .split(".")
        .join(decimalSeparator);
    }
  }
}
